import React, { useState, useEffect, useRef } from 'react';

const UrlDisplayModal = ({ url, title, onClose }) => {
  const [copyStatus, setCopyStatus] = useState('');
  const urlTextRef = useRef(null); // Ref to the span containing the URL

  useEffect(() => {
    // Automatically select the URL text when the modal opens
    if (urlTextRef.current) {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(urlTextRef.current);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }, []); // Run once on mount

  const handleCopyLink = () => {
    if (urlTextRef.current) {
      const textToCopy = urlTextRef.current.textContent;
      // Using navigator.clipboard.writeText() is preferred for modern browsers over execCommand
      // as it's more robust and recommended. However, it requires a secure context (HTTPS)
      // and user gesture. If running on HTTP or in a strict environment, you might
      // need the execCommand fallback. I'll use navigator.clipboard for simplicity.
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy)
          .then(() => {
            setCopyStatus('Copied!');
            setTimeout(() => setCopyStatus(''), 2000); // Clear status after 2 seconds
          })
          .catch(err => {
            console.error('Failed to copy text (navigator.clipboard): ', err);
            setCopyStatus('Failed to copy.');
            setTimeout(() => setCopyStatus(''), 2000); // Clear status after 2 seconds
          });
      } else {
        // Fallback for older browsers or non-secure contexts if needed
        const tempInput = document.createElement('input');
        document.body.appendChild(tempInput);
        tempInput.value = textToCopy;
        tempInput.select();
        try {
          document.execCommand('copy');
          setCopyStatus('Copied!');
        } catch (err) {
          console.error('Failed to copy text (execCommand): ', err);
          setCopyStatus('Failed to copy.');
        }
        document.body.removeChild(tempInput);
        setTimeout(() => setCopyStatus(''), 2000); // Clear status after 2 seconds
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">{title}</h2>
        <p className="modal-url">
          <span className="url-label">Please copy the link:</span>
          <span
            ref={urlTextRef} // Attach ref here
            className="url-text selectable-url" // Add a class for styling/selection
            onClick={handleCopyLink} // Allow click to copy
            title="Click to copy link" // Tooltip
          >
            {window.location.origin + url}
          </span>
        </p>
        <div className="modal-actions">
          {/* Removed the 'Open Link in New Tab' button */}
          <button className="modal-button close-button" onClick={onClose}>
            Close
          </button>
        </div>
        {copyStatus && <span className="copy-status">{copyStatus}</span>} {/* Display copy status */}
      </div>
    </div>
  );
};

export default UrlDisplayModal;